import type React from 'react';

import { useSkeletonContext } from '../context/LoadingSkeletonContext';
import type { SkeletonShapeProps } from '../types';

import { CircleStyles } from './Circle.styles';

export const Circle: React.FC<SkeletonShapeProps> = (props) => {
	const { className = '', size, loading: loadingProp } = props;

	const { loading, shapeSize, shapeColorClassName } = useSkeletonContext();

	const resolvedLoading = loadingProp ?? loading;
	const resolvedSize = size || shapeSize;
	const mergedClassName = `${shapeColorClassName} ${className}`.trim();

	const styles = CircleStyles({ loading: resolvedLoading, size: resolvedSize, class: mergedClassName });

	return <div data-shape="circle" className={styles} />;
};
